module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticesRowArmsFolded-8d1e0374293625adce385ef4a156323c.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticesRowArmsFolded.png
// module id = 2440
// module chunks = 2